// ============================================================================
// REQUEST TYPES ENDPOINTS - Digital Approval System
// ============================================================================
// API endpoint definitions for Request Types operations

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/das/request-types';

/**
 * Request Types API Endpoints
 */
export const requestTypesEndpoints = {
  /**
   * Get all request types with pagination and filtering
   */
  list: () => buildEndpoint(BASE_PATH),

  /**
   * Get all active request types (most useful for forms)
   */
  active: () => buildEndpoint(`${BASE_PATH}/active`),

  /**
   * Get request type by ID
   */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Get request type by code
   */
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /**
   * Get request types by workflow template
   */
  getByWorkflowTemplate: (workflowTemplateId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/workflow-template/:workflowTemplateId`, {
      workflowTemplateId,
    }),

  /**
   * Create new request type
   */
  create: () => buildEndpoint(BASE_PATH),

  /**
   * Update existing request type
   */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Delete request type (soft delete)
   */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Validate request type code uniqueness
   */
  validateCode: (code: string, excludeId?: ID) => {
    const endpoint = buildEndpointWithParams(`${BASE_PATH}/validate/code/:code`, { code });
    return excludeId ? `${endpoint}?excludeId=${excludeId}` : endpoint;
  },
};

export default requestTypesEndpoints;
